module.exports = __webpack_public_path__ + "img/example9-2.3f0486b0.png";